module.exports = __webpack_public_path__ + "static/img/DZ@2x.82fb660b.jpg";